import api from "../api/api";
import {
  GET_MY_MACROS,
  GET_MY_MACROS_ERROR,
  GET_SINGLE_MACRO,
  GET_SINGLE_MACRO_ERROR,
  RESET_MACROS_DATA,
  UPDATE_MACRO_EVENT_SERVINGS,
  POST_MACRO_EVENT_SERVINGS,
  UPDATE_MACRO_EVENT_SERVINGS_ERROR,
  GET_RECIPE_HISTORY,
  SET_RECIPE_HISTORY,
  RECIPE_HISTORY_ERROR,
  REMOVE_MACRO_EVENT,
  SET_MY_MACROS,
  SET_SINGLE_MACRO,
} from "./types";

import store from "../store";

export const getMyMacros = (date) => async (dispatch) => {
  try {
    dispatch({
      type: GET_MY_MACROS,
    });
    const now = new Date();
    const localDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const today = localDate.toISOString().split("T")[0];

    const res = await api.get(`/insights/my/macros/${date}?currentDate=${today}`);

    console.log(res.data);

    dispatch({
      type: SET_MY_MACROS,
      payload: {
        data: res.data,
        date: today,
      },
    });
  } catch (error) {
    dispatch({
      type: GET_MY_MACROS_ERROR,
    });
  }
};

export const getSingleMacro = (macroID, date) => async (dispatch) => {
  try {
    dispatch({
      type: GET_SINGLE_MACRO,
      payload: { id: macroID },
    });
    const now = new Date();
    const localDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const today = localDate.toISOString().split("T")[0];
    const res = await api.get(`/insights/macro/${macroID}/${date}?currentDate=${today}`);

    console.log(res.data);
    dispatch({
      type: SET_SINGLE_MACRO,
      payload: {
        id: macroID,
        data: res.data,
      },
    });
  } catch (error) {
    dispatch({
      type: GET_SINGLE_MACRO_ERROR,
    });
  }
};

export const resetMacrosData = () => (dispatch) => {
  dispatch({
    type: RESET_MACROS_DATA,
  });
};

export const updateMacroEventServings =
  (eventId, historySectionIndex, macroSectionIndex, servingsEaten) => async (dispatch) => {
    try {
      dispatch({
        type: POST_MACRO_EVENT_SERVINGS,
      });

      const res = await api.put(`/macros/event/${eventId}/servings`, {
        sectionIndex: macroSectionIndex,
        servingsEaten,
      });

      dispatch({
        type: UPDATE_MACRO_EVENT_SERVINGS,
        payload: {
          historySectionIndex,
          macroSectionIndex,
          servingsEaten,
        },
      });

      return res.data;
    } catch (error) {
      console.log("Error updating macro event servings:", error);
      dispatch({
        type: UPDATE_MACRO_EVENT_SERVINGS_ERROR,
        payload: error.response?.data?.msg || "Error updating servings",
      });
      return null;
    }
  };

export const getRecipeHistory = (date) => async (dispatch) => {
  try {
    dispatch({
      type: GET_RECIPE_HISTORY,
    });

    const currentDate = date.toISOString().split("T")[0];
    const response = await api.post("/insights/meals", { date: currentDate });

    dispatch({
      type: SET_RECIPE_HISTORY,
      payload: {
        date: date,
        data: response.data.recipeHistory,
      },
    });
  } catch (error) {
    dispatch({
      type: RECIPE_HISTORY_ERROR,
    });
  }
};

export const removeMacroEvent = (macroID) => async (dispatch) => {
  try {
    const res = await api.delete(`/macros/event/${macroID}`);

    const state = store.getState();

    let newHistory = [];

    for (let i = 0; i < state.insights.recipeHistory.length; i++) {
      if (state.insights.recipeHistory[i]?.macros?.id !== macroID) {
        newHistory.push(state.insights.recipeHistory[i]);
      }
    }

    dispatch({
      type: REMOVE_MACRO_EVENT,
      payload: newHistory,
    });

    return true;
  } catch (error) {
    console.log("Error removing macro event:", error);
    return null;
  }
};
